import createLazyComponent from '../LazyComponent';

const Products = createLazyComponent(() => import('./ProductsPage'));

export default Products;
